// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.content_WAKJc { 
  width: 800px;
  height: calc( 80vh - 200px );
  position : relative;
}

.layout_GueW_ {
  display : grid;
  grid-template-columns: 50% 50%;
  column-gap: var( --size-padMedium, 8px );
  row-gap: var( --size-padMedium, 8px );
  justify-items: stretch;
  align-items: center;

}

.grid_tybQy {
  display : grid;
  grid-template-columns: auto auto;
  grid-template-columns: auto auto;
  column-gap: var( --size-padMedium, 8px );
  row-gap: var( --size-padMedium, 8px );
  justify-items: stretch;
  align-items: center;
}

.metadata_fHUJr {
  justify-self: left;
  
}

.current_HAayD {
  min-width : 400px;
  overflow : auto;
  border-left : 3px solid var( --color-base100, #eeeeee );
}

.currentSection_UbeTV {
  
  left : var( --size-padMedium, 8px ) !important;
}`, "",{"version":3,"sources":["webpack://./src/screens/role/EditPermissions.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,wCAAwC;EACxC,qCAAqC;EACrC,sBAAsB;EACtB,mBAAmB;;AAErB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,uDAAuD;AACzD;;AAEA;;EAEE,8CAA8C;AAChD","sourcesContent":["\n.content { \n  width: 800px;\n  height: calc( 80vh - 200px );\n  position : relative;\n}\n\n.layout {\n  display : grid;\n  grid-template-columns: 50% 50%;\n  column-gap: var( --size-padMedium, 8px );\n  row-gap: var( --size-padMedium, 8px );\n  justify-items: stretch;\n  align-items: center;\n\n}\n\n.grid {\n  display : grid;\n  grid-template-columns: auto auto;\n  grid-template-columns: auto auto;\n  column-gap: var( --size-padMedium, 8px );\n  row-gap: var( --size-padMedium, 8px );\n  justify-items: stretch;\n  align-items: center;\n}\n\n.metadata {\n  justify-self: left;\n  \n}\n\n.current {\n  min-width : 400px;\n  overflow : auto;\n  border-left : 3px solid var( --color-base100, #eeeeee );\n}\n\n.currentSection {\n  \n  left : var( --size-padMedium, 8px ) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_WAKJc`,
	"layout": `layout_GueW_`,
	"grid": `grid_tybQy`,
	"metadata": `metadata_fHUJr`,
	"current": `current_HAayD`,
	"currentSection": `currentSection_UbeTV`
};
export default ___CSS_LOADER_EXPORT___;
